module.exports = __webpack_public_path__ + "img/152.23686e6d.jpg";